export default "__VITE_ASSET__xsmGYv2E__"